import { render, staticRenderFns } from "./MarkdownList.vue?vue&type=template&id=fc20a12e&scoped=true"
import script from "./MarkdownList.vue?vue&type=script&lang=js"
export * from "./MarkdownList.vue?vue&type=script&lang=js"
import style0 from "./MarkdownList.vue?vue&type=style&index=0&id=fc20a12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc20a12e",
  null
  
)

export default component.exports